const firebaseConfig = {
    apiKey: "AIzaSyBsL4iax8w2y7a-La87fgsml-1pAX8ZGGI",
    authDomain: "covidity-20af2.firebaseapp.com",
    projectId: "covidity-20af2",
    storageBucket: "covidity-20af2.appspot.com",
    messagingSenderId: "417092038966",
    appId: "1:417092038966:web:78205a70a8cdb6e6368397",
    measurementId: "G-XTX3HWZPTG"
  };
export default firebaseConfig;